import { css } from 'styled-components';
import { gradients } from '../../palette/gradients';
import { Language } from '../constants';
export const ButtonType = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary'
};
export const ButtonSize = {
  SMALL: 'small',
  NORMAL: 'normal'
};
export const ButtonColor = {
  PRIMARY_CONTRAST: 'primary_contrast',
  SECONDARY_CONTRAST: 'secondary_contrast',
  LIGHT: 'light',
  DARK: 'dark',
  MONO_900: 'mono_900'
};
export function getCSSRippleEffectAfter(rippleColor) {
  let transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return css(["&:after{content:'';opacity:0;display:block;width:100%;height:100%;position:absolute;top:0;left:0;pointer-events:none;background-image:", ";background-repeat:no-repeat;background-position:center;background-size:", "%;transform:scale(", ");transition:transform 0.3s,opacity 1s;}"], gradients.generateButtonRippleBackgroundCircle(rippleColor), transform ? '500' : '1000', transform ? '2' : '1');
}
export const CSS_RIPPLE_EFFECT_ACTIVE_AFTER = css(["&:after{transform:scale(0);opacity:0.5;transition:0s;}"]);
export const BUTTON_TRANSLATIONS_KEYS = {
  accessibleLabelLoading: 'component.Button.accessibleLabelLoading'
};
export const BUTTON_TRANSLATIONS = {
  [Language.CS]: {
    [BUTTON_TRANSLATIONS_KEYS.accessibleLabelLoading]: 'Načítání...'
  },
  [Language.EN]: {
    [BUTTON_TRANSLATIONS_KEYS.accessibleLabelLoading]: 'Loading...'
  },
  [Language.PL]: {
    [BUTTON_TRANSLATIONS_KEYS.accessibleLabelLoading]: 'Ładowanie...'
  },
  [Language.SK]: {
    [BUTTON_TRANSLATIONS_KEYS.accessibleLabelLoading]: 'Načítavanie...'
  }
};